import React from 'react'
import './banner.scss';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const Banner = ({ totalMarketCap }) => {
  const formatMoneytotal = num => {
    if (!num && num !== 0) return '';
    return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const initialCapital = 100000000;
  const pnl = totalMarketCap - initialCapital;
  const pnlPercent = (pnl / initialCapital) * 100;

  const pnlColor = pnl >= 0 ? '#2F9729' : 'red';

  return (
    <section className='main_banner' id="home">
      <video className='main-banner-video'
        muted="muted" playsinline="playsinline"
        autoPlay
        loop
        width="100%"
        id="myVideo">
        <source src="\assets\bannervideo.mp4" type="video/mp4" />
      </video>
      <div className='custom-container'>
        <div className='inner_banner'>
          <h2>Diversified Exchange Token Treasury</h2>
          <p>A balanced portfolio built on the crypto economy’s most resilient and fastest-growing exchange tokens.</p>
          <h3>Net Asset Value (NAV)</h3>
          <h4>{formatMoneytotal(totalMarketCap)}* <span style={{ color: pnlColor }}>{pnl >= 0 ? "+" : "-"}{pnlPercent.toFixed(2)}%</span></h4>
          <h5>Simulation based on our portfolio allocation*</h5>

          {['top'].map((placement) => (
            <OverlayTrigger
              key={placement}
              placement={placement}
              overlay={
                <Tooltip id={`tooltip-${placement}`}>
                  Coming Soon
                </Tooltip>
              }
            >
              <button className='button_dashboard'>Live Dashboard</button>

            </OverlayTrigger>
          ))}
        </div>
      </div>

    </section>
  )
}

export default Banner
